export enum ChartStatusFilter
{
    All = 'All',
    WithChanges = 'WithChanges'
}